'use strict';
'use es6';

// Prevent unwanted focus styles

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

require('../listeners/focusStylesListener');

var _underscore = require('../utils/underscore');

var _reactAddonsPureRenderMixin = require('react-addons-pure-render-mixin');

var _reactAddonsPureRenderMixin2 = _interopRequireDefault(_reactAddonsPureRenderMixin);

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _reactUtils = require('react-utils');

var _devLogger = require('react-utils/devLogger');

var _devLogger2 = _interopRequireDefault(_devLogger);

var _I18n = require('I18n');

var _I18n2 = _interopRequireDefault(_I18n);

var _Functions = require('../core/Functions');

var _KeyCodes = require('../constants/KeyCodes');

var _validHref = require('../utils/propTypes/validHref');

var _validHref2 = _interopRequireDefault(_validHref);

var _HideFocusOnClick = require('../utils/HideFocusOnClick');

var _HideFocusOnClick2 = _interopRequireDefault(_HideFocusOnClick);

var _UnsafeUrl = require('../utils/UnsafeUrl');

var _Links = require('../utils/Links');

var _ThrowError = require('../utils/ThrowError');

var _LinkConstants = require('./LinkConstants');

var _UIIcon = require('../icon/UIIcon');

var _UIIcon2 = _interopRequireDefault(_UIIcon);

var _icons = require('icons/icons');

var _icons2 = _interopRequireDefault(_icons);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }

exports.default = _react2.default.createClass({
  displayName: 'UILink',

  mixins: [_reactAddonsPureRenderMixin2.default],

  propTypes: {
    children: _react.PropTypes.node,
    className: _react.PropTypes.string,
    disabled: _react.PropTypes.bool,
    external: _react.PropTypes.bool.isRequired,
    href: _validHref2.default,
    iconProps: _react.PropTypes.object.isRequired,
    onClick: _react.PropTypes.func,
    rel: _react.PropTypes.string,
    tabIndex: _react.PropTypes.number,
    target: _react.PropTypes.string,
    underline: _react.PropTypes.bool.isRequired,
    use: _react.PropTypes.oneOf(Object.keys(_LinkConstants.USE_CLASSES)).isRequired
  },

  getDefaultProps: function getDefaultProps() {
    return {
      external: false,
      iconProps: {},
      underline: false,
      use: 'dark'
    };
  },
  getClassName: function getClassName(_ref) {
    var className = _ref.className,
        disabled = _ref.disabled,
        underline = _ref.underline,
        use = _ref.use;

    return (0, _reactUtils.classNames)('private-link', _LinkConstants.UNDERLINE_CLASSES[underline], _LinkConstants.USE_CLASSES[use], { 'private-link--disabled': disabled }, className);
  },
  handleKeyDown: function handleKeyDown(evt) {
    // Simulate click on ENTER/SPACE, to emulate button behavior
    var keyCode = evt.keyCode;


    if (typeof this.props.onClick !== 'function') {
      return;
    }

    if (keyCode === _KeyCodes.ENTER || keyCode === _KeyCodes.SPACE) {
      this.props.onClick(evt);
      evt.preventDefault();
    }
  },
  handleClick: function handleClick(evt) {
    var _props = this.props,
        onClick = _props.onClick,
        disabled = _props.disabled;


    if (disabled) {
      evt.preventDefault();
      evt.stopPropagation();
    } else {
      (0, _Functions.callIfPossible)(onClick, evt);
    }
  },
  getTabIndex: function getTabIndex(_ref2) {
    var disabled = _ref2.disabled,
        href = _ref2.href,
        tabIndex = _ref2.tabIndex;

    if (disabled) {
      return -1;
    } else if (href) {
      return tabIndex;
    }

    return tabIndex || 0;
  },
  getSecurityTaggedLink: function getSecurityTaggedLink(_ref3, _ref4) {
    var href = _ref3.href;
    var link = _ref4.link;

    if ((0, _UnsafeUrl.isUnsafeUrl)(href)) {
      (0, _ThrowError.throwErrorAsync)(new Error('UILink: Detected XSS attempt! href="' + href + '"'));
      return _react2.default.createElement(
        _UnsafeUrl.XSSTooltip,
        null,
        link
      );
    }
    return link;
  },
  renderExternalLinkIcon: function renderExternalLinkIcon(_ref5) {
    var external = _ref5.external,
        iconProps = _ref5.iconProps;

    if (!external) return null;

    // Opening links in a new window is an accessibility anti-pattern.
    // To mitigate this, we add accessible text in the icon to warn that
    // the link will be opened in a new window
    // @link http://diveintoaccessibility.info/day_16_not_opening_new_windows.html

    var className = (0, _reactUtils.classNames)('private-link--external__icon', iconProps.className);

    return _react2.default.createElement(_UIIcon2.default, _extends({}, iconProps, {
      'aria-label': _I18n2.default.text('salesUI.UILink.externalTitle'),
      className: className,
      name: _icons2.default.EXTERNALLINK
    }));
  },
  render: function render() {
    var propsNotUsedInRender = ['onClick'];

    var _omit = (0, _underscore.omit)(this.props, propsNotUsedInRender),
        children = _omit.children,
        className = _omit.className,
        disabled = _omit.disabled,
        external = _omit.external,
        href = _omit.href,
        iconProps = _omit.iconProps,
        rel = _omit.rel,
        tabIndex = _omit.tabIndex,
        target = _omit.target,
        underline = _omit.underline,
        use = _omit.use,
        rest = _objectWithoutProperties(_omit, ['children', 'className', 'disabled', 'external', 'href', 'iconProps', 'rel', 'tabIndex', 'target', 'underline', 'use']);

    if (!external && target === '_blank') {
      _devLogger2.default.warn({
        message: 'UILink: You can use the `external` prop to automatically set ' + 'target="_blank" which adds a trailing external link icon.',
        key: 'UILink: using target directly'
      });
    }

    var computedTarget = (0, _Links.getTarget)({ external: external, target: target });
    var computedRel = (0, _Links.getRel)({ rel: rel }, { computedTarget: computedTarget });

    var link = _react2.default.createElement(
      'a',
      _extends({}, rest, {
        className: this.getClassName({ className: className, disabled: disabled, underline: underline, use: use }),
        onClick: this.handleClick,
        onKeyDown: this.handleKeyDown,
        href: (0, _UnsafeUrl.getSafeUrl)(href),
        rel: computedRel,
        role: href ? undefined : 'button',
        tabIndex: this.getTabIndex({ disabled: disabled, href: href, tabIndex: tabIndex }),
        target: computedTarget,
        'aria-disabled': disabled
      }),
      children,
      this.renderExternalLinkIcon({ external: external, iconProps: iconProps })
    );

    return _react2.default.createElement(
      _HideFocusOnClick2.default,
      null,
      this.getSecurityTaggedLink({ href: href }, { link: link })
    );
  }
});
module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// /usr/share/hubspot/build/.hubspot/static-archive/UIComponents/static-2.348/js/link/UILink.js
// module id = 140
// module chunks = 0 1